/* cian.serp */
angular.module('cian.serp', ['userService', 'cian.ui.button', 'cian.serp.item', 'cian.ui.popup', 'cian.ui.modal', 'cian.newbuild.serp'])
.config(["$interpolateProvider", function($interpolateProvider) {
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
}]);




//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.js
// module id = 488
// module chunks = 0